import { render, staticRenderFns } from "./AmazingProduct.vue?vue&type=template&id=0b8e0090&"
import script from "./AmazingProduct.vue?vue&type=script&lang=js&"
export * from "./AmazingProduct.vue?vue&type=script&lang=js&"
import style0 from "./AmazingProduct.vue?vue&type=style&index=0&id=0b8e0090&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports